import { render, staticRenderFns } from "./orderValueSummaryList.vue?vue&type=template&id=fb3a9e12&"
import script from "./orderValueSummaryList.vue?vue&type=script&lang=js&"
export * from "./orderValueSummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports